import { Component, Input } from '@angular/core';
import { DatePipe } from "@angular/common";
import { Lookup } from '../../models/lookupmodel';
import { Acct } from '../../models/acctmodel';
import { AccountUpdate } from '../../models/accountupdatemodel';
import { Topup } from '../../models/topupmodel';
import { paymentService } from '../../services/payment.service';
import { SharedService } from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { PaymentResponse } from '../../models/responsemodel';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import * as xml2js from 'xml2js';

@Component({
  templateUrl: './lookup.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [paymentService]
})

export class LookupComponent {
  @Input() responseObj: Session;
  public request: Lookup;
  public data;
  public acct: Acct;
  public acctupdate: AccountUpdate;
  public topup: Topup;
  errorMessage: string;
  public itemResource;
  items = [];
  itemCount = 0;

  constructor(public _paymentService: paymentService, public router: Router, public sharedservice: SharedService) {

  }

  ngOnInit() {
    this.request = new Lookup();
    localStorage.removeItem("lookup");
  }

  accountLookup(isValid: boolean) {
    if (isValid) {
      localStorage.setItem("smartcard", this.request.smartcard);
      this._paymentService.accountLookup(this.request).subscribe(res => this.handleResponse(res), error => this.errorMessage = <any>error);
    }
  }


  handleResponse(result) {
    var requestres = "";
    xml2js.parseString(result._body.toString(), function (err, res) {
      var jsonstring = JSON.parse(JSON.stringify(res));
      /*console.log(JSON.stringify(res)); // Prints JSON object!
      console.log("MerchantReference: "+ jsonstring['PayUVasResponse']['MerchantReference']);
      console.log("PayUVasReference: "+ jsonstring['PayUVasResponse']['PayUVasReference']);
      console.log("ResultCode: "+ jsonstring['PayUVasResponse']['ResultCode']);
      console.log("VasProviderReference: "+ jsonstring['PayUVasResponse']['VasProviderReference']);
      console.log("CustomFields: "+ JSON.stringify(jsonstring['PayUVasResponse']['CustomFields'][0]['CustomField']));
      console.log("CustomFields: "+ jsonstring['PayUVasResponse']['CustomFields'][0]['Customfield'][0]['$']['Value']);*/
      var count = jsonstring['PayUVasResponse']['CustomFields'][0]['Customfield'].length;
      requestres = jsonstring['PayUVasResponse']['ResultCode'];

      localStorage.setItem("lookup", JSON.stringify(res));

      for (let index = 0; index < count; index++) {
        console.log(jsonstring['PayUVasResponse']['CustomFields'][0]['Customfield'][index]['$']['Key'] + ' : ' + jsonstring['PayUVasResponse']['CustomFields'][0]['Customfield'][index]['$']['Value']);
      }

    });

    if (requestres == "00") {
      this.router.navigate(['mca/payment']);
    }


  }


}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/payment/lookup.component.ts